<!--eslint-disable-->
<template>
  <div :class="classObj" class="layout-main">
<!--    <Head />-->
    <div class="main-container">
      <div class="sidebar-container">
        <Logo></Logo>
        <Sidebar />
      </div>
      <div class="content-container">
        <div class="navicon-con">
          <div class="conButton" type="text" @click="toggleClick">
            <svg-icon
              :style="{
              transform: 'rotateZ(' + (!this.sidebar.opened ? '-180' : '0') + 'deg)'
              }"
              class="head-icon-shouqi"
              icon-class="shouqi"/>
          </div>
        </div>
        <Head />
        <div class="view-container" id="main-content">
          <Breadcrumb v-if="$route.name !== 'Home'"/>
          <!-- 页面跳转动画 -->
          <transition name="fade-transform-right" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Head from '@/layout/components/Head/Head.vue';
import Sidebar from '@/layout/components/Sidebar/index.vue';
import Breadcrumb from '@/layout/components/Breadcrumb/index.vue';
import Logo from '@/layout/components/Logo/index.vue'
import { mapState } from 'vuex';

export default {
  name: 'layoutMain',
  components: {
    Head,
    Sidebar,
    Breadcrumb,
    Logo
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      currentTheme: state => state.user.userInfo.skin === 1 ? "dark": "light"
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
        ['theme-' + this.currentTheme]: true
      }
    },
    isCollapse() {
      return this.sidebar.opened;
    }
  },
  mounted () {
    this.$store.dispatch('getUserInfo');
  },
  methods: {
    toggleClick () {
      this.$store.dispatch('app/toggleSideBar');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
@import './index.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px)
}

.mobile .fixed-header {
  width: 100%;
}

</style>
